<template>
  <div id="err_wrapper">
    <div>
      <errmain />
    </div>
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 174.39 181.59"
      >
        <defs>
          <clipPath
            id="bfeb499f-688d-44f0-837c-2494e2a80e2e"
            transform="translate(0.05)"
          >
            <path
              d="M17.3,86.65,27,84.84,42.16,82.2C57,79.43,62.34,79.54,62.34,79.54c7.75-.89,25.93,3.21,25.93,3.21L107.34,87c8.53,1.77,13.23-3.52,13.23-3.52C143.34,61,152.68,38.08,152.68,38.08c9.53-22.83,3-38.08,3-38.08h17.62c1.89,6.15.67,18.46.67,18.46C173.07,47.62,149.9,76.1,149.9,76.1,142,86.19,126.74,99.71,126.74,99.71c-2.55,1.89-6.76,7.87-6.76,7.87l-19.29,29.71a65.38,65.38,0,0,1-19,17.29c-.33.11-47.89,27-47.89,27-13.31-4.36-20.94-22-20.94-22C1.63,134-.52,116.74.09,105.73c.63-11.31,4.2-15.48,4.72-16.2L5.3,89l3-.59Z"
              style="fill: none"
            />
          </clipPath>
          <linearGradient
            id="f507c1fc-1c2a-4279-aad4-0f53e0807a33"
            x1="20.08"
            y1="207.85"
            x2="23.74"
            y2="87.97"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#7e55ff" />
            <stop offset="0.98" stop-color="#5f61ef" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="b3d53d66-c155-466d-83f0-7489b9af1099"
            x1="53.48"
            y1="114.44"
            x2="12.91"
            y2="139.39"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#8f38ff" />
            <stop offset="0.95" stop-color="#b74dff" stop-opacity="0.05" />
            <stop offset="0.98" stop-color="#5f61ef" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="e85780ac-73b0-407c-82d8-f256330e6182"
            x1="-15.01"
            y1="161.59"
            x2="27.11"
            y2="129.66"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#3d3879" />
            <stop offset="0.98" stop-color="#5f61ef" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="bd89e04e-66e1-4ad5-be6d-98f31a8d891c"
            x1="89.99"
            y1="54.87"
            x2="97.14"
            y2="176.58"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#58007f" />
            <stop offset="0.98" stop-color="#00adef" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="e36b843f-6839-4268-ae99-b78d9177841c"
            x1="-57.25"
            y1="-59.39"
            x2="-55.84"
            y2="-25.7"
            gradientTransform="matrix(0.92, 0.36, -0.3, 1.11, 55.14, 202.34)"
            xlink:href="#bd89e04e-66e1-4ad5-be6d-98f31a8d891c"
          />
          <linearGradient
            id="e9cde52a-9637-4196-aadd-8b92ac64cb21"
            x1="-44.28"
            y1="-59.92"
            x2="-42.86"
            y2="-26.24"
            gradientTransform="matrix(0.92, 0.36, -0.3, 1.11, 54.05, 197.93)"
            xlink:href="#bd89e04e-66e1-4ad5-be6d-98f31a8d891c"
          />
        </defs>
        <g id="b7115c93-a935-4ded-85e4-e1e468e76024" data-name="레이어 2">
          <g
            id="b98ebfe3-5255-44de-b6ac-5d5fb1f4c32a"
            data-name="background-color"
          >
            <g style="clip-path: url(#bfeb499f-688d-44f0-837c-2494e2a80e2e)">
              <path
                d="M41.88,130.58c6.18,25.7,2.48,45.26-8,51-7.31-.74-21.92-17.08-28.87-41.53C-2.68,113.15-.79,95.45,5.3,89,15.61,89.38,34.76,102.16,41.88,130.58Z"
                transform="translate(0.05)"
                style="fill: #9fddff"
              />
              <path
                d="M41.88,130.58c6.18,25.7,2.48,45.26-8,51-7.31-.74-21.92-17.08-28.87-41.53C-2.68,113.15-.79,95.45,5.3,89,15.61,89.38,34.76,102.16,41.88,130.58Z"
                transform="translate(0.05)"
                style="fill: url(#f507c1fc-1c2a-4279-aad4-0f53e0807a33)"
              />
              <path
                d="M41.88,130.58c6.18,25.7,2.48,45.26-8,51-7.31-.74-21.92-17.08-28.87-41.53C-2.68,113.15-.79,95.45,5.3,89,15.61,89.38,34.76,102.16,41.88,130.58Z"
                transform="translate(0.05)"
                style="fill: url(#b3d53d66-c155-466d-83f0-7489b9af1099)"
              />
              <path
                d="M41.88,130.58c6.18,25.7,2.48,45.26-8,51-7.31-.74-21.92-17.08-28.87-41.53q-.69-2.43-1.31-4.89c-.39-1.55-.76-3.11-1.1-4.68s-.62-3-.9-4.45-.49-2.83-.7-4.24-.36-2.68-.51-4S.21,115.26.12,114,0,111.62,0,110.43s0-2.22,0-3.33S.06,105,.14,104s.19-1.91.32-2.86.28-1.75.47-2.61.36-1.6.6-2.38S2,94.73,2.25,94a19.71,19.71,0,0,1,.85-1.88,16.43,16.43,0,0,1,1-1.62A13.78,13.78,0,0,1,5.27,89c.07-.08.33,0,.43,0l.41,0c.27,0,.55.06.83.1.59.09,1.17.21,1.75.35s1.24.34,1.85.55,1.3.47,1.93.74,1.35.61,2,.94,1.39.74,2.07,1.15,1.41.88,2.1,1.35,1.43,1,2.12,1.55,1.44,1.16,2.13,1.77,1.44,1.3,2.12,2,1.42,1.45,2.1,2.2,1.39,1.59,2.05,2.41,1.35,1.73,2,2.63,1.31,1.89,1.92,2.86,1.25,2,1.83,3.07,1.18,2.19,1.72,3.31,1.1,2.35,1.6,3.54,1,2.5,1.45,3.77.91,2.66,1.31,4C41.31,128.38,41.62,129.48,41.88,130.58Z"
                transform="translate(0.05)"
                style="fill: url(#e85780ac-73b0-407c-82d8-f256330e6182)"
              />
              <path
                d="M173.29,0H155.67c11.56,31.71-21.86,70-35.1,83.45a12.94,12.94,0,0,1-11.9,3.61l-28.76-6a75.29,75.29,0,0,0-28.15-.48l-34.84,6L5.76,88.54A5.33,5.33,0,0,0,5,89a20.74,20.74,0,0,1,4.8.79c12.69,3.65,25.41,19.05,31.34,39.73,6.3,22,2.92,43-7.29,52l44.08-24.67a75.28,75.28,0,0,0,26.75-25.28l14.1-22.15a50.19,50.19,0,0,1,9.43-11C185.28,48.93,173.29,0,173.29,0Z"
                transform="translate(0.05)"
                style="fill: #a1f4ff"
              />
              <path
                d="M173.29,0H155.67c11.56,31.71-21.86,70-35.1,83.45a12.94,12.94,0,0,1-11.9,3.61l-28.76-6a75.29,75.29,0,0,0-28.15-.48l-34.84,6L5.76,88.54A5.33,5.33,0,0,0,5,89a20.74,20.74,0,0,1,4.8.79c12.69,3.65,25.41,19.05,31.34,39.73,6.3,22,2.92,43-7.29,52l44.08-24.67a75.28,75.28,0,0,0,26.75-25.28l14.1-22.15a50.19,50.19,0,0,1,9.43-11C185.28,48.93,173.29,0,173.29,0Z"
                transform="translate(0.05)"
                style="fill: url(#bd89e04e-66e1-4ad5-be6d-98f31a8d891c)"
              />
              <rect
                x="13.35"
                y="125.77"
                width="3.06"
                height="25.33"
                rx="1.43"
                transform="translate(-45.61 13.05) rotate(-19.64)"
                style="fill: #33115b"
              />
              <rect
                x="25.54"
                y="118.62"
                width="3.06"
                height="28.93"
                rx="1.43"
                transform="translate(-43.1 16.84) rotate(-19.64)"
                style="fill: #33115b"
              />
              <rect
                x="13.35"
                y="125.77"
                width="3.06"
                height="25.33"
                rx="1.43"
                transform="translate(-45.61 13.05) rotate(-19.64)"
                style="fill: url(#e36b843f-6839-4268-ae99-b78d9177841c)"
              />
              <rect
                x="25.54"
                y="118.62"
                width="3.06"
                height="28.93"
                rx="1.43"
                transform="translate(-43.1 16.84) rotate(-19.64)"
                style="fill: url(#e9cde52a-9637-4196-aadd-8b92ac64cb21)"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div>
      <errtxt />
    </div>
    <div>
      <router-link to="/">
        <el-button><i class="el-icon-s-home pr-10"></i>홈으로 이동</el-button>
      </router-link>
    </div>
  </div>
</template>
<script>
import errmain from "../../../../public/img/svg/err/error_page_inline.svg?inline";
// import errlight from "../../../../public/img/svg/err/error_page_plug.svg?inline";
import errtxt from "../../../../public/img/svg/err/error_page_txt.svg?inline";
import { Button } from "element-ui";

export default {
  components: {
    errmain,
    // errlight,
    errtxt,
    [Button.name]: Button,
  },
  data() {
    return {
      // errlight: require("../../public/img/svg/err/error_page_plug.svg"),
    };
  },
};
</script>
<style scoped>
div#err_wrapper {
  width: 100%;
  height: 100vh;
  position: relative;
  background-color: #00000000;
  overflow: hidden;
}
div#err_wrapper div:nth-child(1) {
  width: 90%;
  background-color: #ff000000;
  position: absolute;
  bottom: 0;
  left: 0;
}
div#err_wrapper div:nth-child(1) svg {
  display: block;
  width: 100%;
  position: absolute;
  bottom: -5vh;
  left: 0;
}
div#err_wrapper div:nth-child(2) {
  width: 25vh;
  height: 25vh;
  background-color: #ffff0000;
  position: absolute;
  top: 0;
  right: 1vw;
  z-index: 2;
}
div#err_wrapper div:nth-child(3) {
  width: 40%;
  height: 30%;
  background-color: #ff00ff00;
  position: absolute;
  right: 3vw;
  top: 30%;
}
div#err_wrapper div:nth-child(4) {
  position: absolute;
  right: 4%;
  bottom: 28%;
}
div#err_wrapper div:nth-child(4) .el-button {
  font-size: 1.2rem;
  padding: 1rem 1.5rem;
}

@media screen and (max-width: 1024px) {
  div#err_wrapper div:nth-child(1) {
    width: 100%;
    height: 110vh;
    background-color: #ff000000;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  div#err_wrapper div:nth-child(1) svg {
    width: 100vh;
    bottom: 0;
    left: 0;
  }
  div#err_wrapper div:nth-child(2) {
    width: 30vw;
    height: 30vw;
  }
  div#err_wrapper div:nth-child(3) {
    width: 70%;
    background-color: #ff00ff00;
    position: absolute;
    right: 2vw;
    top: 28vh;
  }
  div#err_wrapper div:nth-child(4) {
    position: absolute;
    right: 4%;
    top: 55vh;
  }
  div#err_wrapper div:nth-child(4) .el-button {
    font-size: 1.5rem;
    padding: 1rem 1.5rem;
  }
}
@media screen and (max-width: 576px) {
  div#err_wrapper div:nth-child(4) {
    position: absolute;
    right: 4%;
    top: 50vh;
  }
  div#err_wrapper div:nth-child(4) .el-button {
    font-size: 0.8rem;
    padding: 0.7rem 0.9rem;
  }
}
@media screen and (max-width: 720px) and (height: 540px) {
div#err_wrapper div:nth-child(2) {
  width: 25vh;
  height: 25vh;
  background-color: #ffff0000;
  position: absolute;
  top: 0;
  right: 1vw;
  z-index: 2;
}
div#err_wrapper div:nth-child(4) {
    position: absolute;
    right: 4%;
    top: 70vh;
  }
}
@media screen and (max-width: 1024px) and (height: 768px) {
div#err_wrapper div:nth-child(2) {
  width: 25vh;
  height: 25vh;
  background-color: #ffff0000;
  position: absolute;
  top: 0;
  right: 1vw;
  z-index: 2;
}
div#err_wrapper div:nth-child(4) {
    position: absolute;
    right: 4%;
    top: 70vh;
  }
}
@media screen and (max-height: 360px) {
  div#err_wrapper div:nth-child(2) {
  width: 20vh;
  height: 20vh;
  background-color: #ffff0000;
  position: absolute;
  top: 0;
  right: 1vw;
  z-index: 2;
}
  div#err_wrapper div:nth-child(4) {
    position: absolute;
    right: 4%;
    top: 80vh;
  }
  div#err_wrapper div:nth-child(4) .el-button {
    font-size: 0.8rem;
    padding: 0.7rem 0.9rem;
  }
}
</style>